import './Badge.scss';

import React, { ReactNode } from 'react';

import { cn } from '@/util/ui';

type BadgeProps = {
  label: string;
  className?: string;
  children?: ReactNode;
};

const Badge = ({ label, className = '', children }: BadgeProps) => {
  return (
    <span className={cn('badge-container', className)}>
      {label}
      {children}
    </span>
  );
};

export default Badge;
